<app-programtitle title="Find whether a given number is positive, negative or zero"></app-programtitle>
<p> Write a program to find whether a given number is positive or negative or zero. </p>

<p>The <b>elif</b> (else if) statement gets executed if the condition in the <b>if</b> statement fails. If the condition given in the <b>elif</b> fails then the <b>else</b> statement code block gets executed.</p>

<p>Multiple <b>elif</b> statements are allowed.</p>
<app-editor code="{{program}}"> </app-editor>

